import { IEmployee } from 'typings/employee';
import { TeamDecisionStore } from 'nomst/Stores/Decision/teamDecision.store';

export class EmployeeGet {
    _teamDecisionStore: TeamDecisionStore;

    constructor(team: TeamDecisionStore) {
        this._teamDecisionStore = team;
    }

    allEmployees(): IEmployee[] {
        return this._teamDecisionStore.allEmployees() as unknown as IEmployee[];
    }
}

export default { EmployeeGet };